import MuiColor from "components/MuiExtras/Typography/MuiColor";
import { UsernameResolver } from "components/UsernameInspect";
import UserProfileLink from "components/UserProfileLink";
import { Formaters } from "lib/Formarters";
import { UserShortView } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
    user: UserShortView;
    date: Date;
}

type Props = IProps;

const RecordModifierInfo: React.FC<Props> = (props) => {
    const { t } = useTranslation();

    return props.user == null
        ? null
        : (
            <>
                <span>{t("Common.RecordInfo.ModifiedByText")}</span>&nbsp;
                {
                    props.user.isSystemUser === true
                        ? <MuiColor variant="muted"><b>{UsernameResolver(props.user)}</b></MuiColor>
                        : <UserProfileLink user={props.user} />
                }
                <span> {Formaters.relativeTime(props.date)}</span>
            </>
        );
};

export default RecordModifierInfo;
